
module.exports = {
  purge: [
    './resources/js/themes/default/**/*.vue',
  ],
  plugins: [
    require('@tailwindcss/line-clamp'),
  ],
  theme: {
    extend: {
      gridTemplateColumns: {
        'header': '79px 1fr 1fr',
        'bannerOpenHouse': 'auto 1fr minmax(110px, auto)',
      },
      gridTemplateRows: {
        'header': '1fr auto auto',
      },
      colors: {
        'primary': '#003b5c',
        'secondary': '#00aed6',
        'status-active': '#7ED321',
        'status-sold' : '#FF0000',
        'status-pending' : '#FF8800',
        'success': '#6DD400',
      },
      height: {
        homepic: '700px',
      },
    },
  },
  variants: {
  },
}
